<template>
  <div ref="combobox" class="w-full relative">
    <div class="flex flex-col">
      <div
        class="cloud_input relative overflow-x-auto whitespace-nowrap border border-gray-300 rounded-md p-2 pr-8 flex items-center"
        :contenteditable="select ? 'false' : 'true'" data-placeholder="--Enter Level Details--" @click="toggleDropdown">
        <div class="w-full flex flex-wrap gap-2">
          <span v-for="(tag, index) in selectedTags" :key="index"
            class="tag flex items-center bg-blue-200 text-blue-800 rounded-full px-3 py-1" contenteditable="false">
            {{ tag.name }}
            <span class="remove-tag cursor-pointer ml-2 text-red-500" @click.stop="removeTag(tag)">
              x
            </span>
          </span>
        </div>
        <span class="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none" v-if="select">
          <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.35124 6.95373L0.215046 2.19059C-0.273086 1.63017 0.123629 0.75 0.864453 0.75H9.13683C9.30263 0.749857 9.46495 0.797864 9.60437 0.888273C9.74378 0.978681 9.85437 1.10766 9.92289 1.25976C9.99142 1.41186 10.015 1.58064 9.99074 1.74588C9.9665 1.91112 9.8955 2.06582 9.78624 2.19146L5.65005 6.95286C5.5691 7.04619 5.46927 7.12099 5.35726 7.17224C5.24526 7.22348 5.12366 7.25 5.00064 7.25C4.87763 7.25 4.75603 7.22348 4.64402 7.17224C4.53202 7.12099 4.43219 7.04619 4.35124 6.95286V6.95373Z"
              fill="#321C3B" />
          </svg>
        </span>
      </div>
    </div>
    <!----<c-text
      placeholder="--Enter Level Details--"
      variant="w-full h-10"
      style="height: 40px !important"
      v-model="searchQuery"
      @input="[(isOpen = true), filterOptions]"
    />

    Dropdown Menu -->
    <div v-if="isOpen"
      class="absolute z-10 w-full bg-white border border-gray-300 rounded-lg max-h-60 flex flex-col gap-2 overflow-auto shadow-lg"
      style="margin-top: 6px">
      <div v-for="(option, index) in filteredOptions" :key="index"
        @click="option.disabled ? null : option.checked ? removeOption(option) : selectOption(option)"
        class="cursor-pointer px-4 py-2">
        <span class="flex w-auto cursor-pointer z-50 gap-1">
          <span class="flex">
            <checkbox checkbox-size="height:16px; width:16px; margin-top: 5px; cursor: pointer"
              :disabled="option.disabled" v-model="option.checked"
              @change="option.checked ? removeOption(option) : selectOption(option)" />
          </span>
          <span class="text-sm flex flex-col justify-center" style="margin-top: 3px">{{ option.name }}</span>
        </span>
      </div>

      <!-- No options available message -->
      <div class="mt-1 flex flex-col gap-3 px-4 py-4" v-if="!noCustom">
        <div class="flex w-auto gap-2">
          <icon icon-name="icon-plus" class="text-flame" size="xms" />
          <p class="text-sm text-flame font-semibold">Add Custom</p>
        </div>

        <div class="flex w-full flex-col gap-5">
          <divider class="my-1" />
          <c-text placeholder="--Enter--" variant="w-full h-10" v-model="customTag" style="height: 40px !important" />
          <div class="flex flex-end justify-end gap-3">
            <span class="flex w-auto gap-1 cursor-pointer" @click="$emit('addTag', customTag)">
              <p class="text-sm font-semibold mx-1 text-flame">Save</p>
            </span>
            <span class="w-auto cursor-pointer" @click="[isOpen = false, searchQuery = '', customTag = '']">
              <p class="text-sm font-semibold mx-1">Cancel</p>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CText from "@scelloo/cloudenly-ui/src/components/text";
import Checkbox from "./Checkbox";
import Divider from "./divider";

export default {
  name: "ComboBox",
  components: { CText, Checkbox, Divider },
  props: {
    options: {
      type: Array,
      default: () => { },
    },
    noCustom: {
      type: Boolean,
      default: false,
    },
    exclusiveOptionId: {
      type: [String, Number],
      default: null
    },
    select: {
      type: Boolean,
      default: false
    },
    isCompensation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addCustom: false,
      searchQuery: "", // Input field value
      selectedOption: null, // Selected option
      isOpen: false, // Dropdown visibility
      customTag: "",
      selectedTags: [],
    };
  },
  computed: {
    filteredOptions() {
      return this.options
    }
  },

  watch: {
    // Watch searchQuery and filter options automatically when searchQuery changes
    searchQuery() {
      this.filterOptions();
    },

    options: {
      handler(newOptions) {
        const allLocations = newOptions.find(opt => opt.id === this.exclusiveOptionId && opt.checked);

        if (allLocations) {
          this.selectedTags = [allLocations]; // Set only "All Locations" when selected
        } else {
          this.selectedTags = newOptions.filter(opt => opt.checked); // Only options with checked = true
        }
      },
      deep: true, // Watches for changes inside objects within the array
      immediate: true, // Runs once when the component mounts
    },
  },

  methods: {
    // Filter options based on the search query
    filterOptions() {
      if (this.searchQuery === "") {
        this.filteredOptions = this.options;
      } else {
        this.filteredOptions = this.options.filter((option) =>
          option.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
    },

    toggleDropdown() {
      if (this.select) {
        this.isOpen = !this.isOpen
      }
      else {
        this.isOpen = true;
      }
    },

    selectOption(option) {
      if (!option) return;

      // Case 1: "All Locations" selected
      if (option.id === this.exclusiveOptionId) {
        this.options.forEach(opt => {
          opt.checked = true;
          opt.disabled = opt.id !== this.exclusiveOptionId; // Disable all except "All Locations"
        });

        // Emit only "All Locations"
        this.selectedTags = [{ id: option.id, name: option.name }];
        this.$emit('addSelectedTags', this.selectedTags);
      }
      // Case 2: Selecting a specific location
      else {
        const allLocations = this.options.find(opt => opt.id === this.exclusiveOptionId);
        if (allLocations) {
          allLocations.checked = false;
          this.options.forEach(opt => opt.disabled = false); // Enable all options
        }

        option.checked = !option.checked;

        // Only get the options that are checked and not "All Locations"
        this.selectedTags = this.options.filter(opt => opt.checked && opt.id !== this.exclusiveOptionId);
        this.$emit('addSelectedTags', this.selectedTags);
      }
      if (!this.isCompensation) {
        this.isOpen = false;
      }
    },

    removeOption(option) {
      if (!option) return;

      if (option.id === this.exclusiveOptionId) {
        // If "All Locations" is removed, uncheck and enable all options
        this.options.forEach(opt => {
          opt.checked = false;
          opt.disabled = false;
        });

        this.selectedTags = []; // Clear selectedTags
        this.$emit('removeTag', option.id);
      } else {
        option.checked = false; // Uncheck the option

        // Update selectedTags to only include checked options
        this.selectedTags = this.options.filter(opt => opt.checked);

        // If no selected options remain, enable all options
        if (this.selectedTags.length === 0) {
          this.options.forEach(opt => opt.disabled = false);
        }

        this.$emit('removeTag', option.id);
      }
    },

    // Update the display dynamically based on selection
    computedSelectedTags() {
      const selected = this.options.filter(opt => opt.checked);
      if (selected.some(opt => opt.id === this.exclusiveOptionId)) {
        return [{ id: this.exclusiveOptionId, name: "All Locations" }];
      }
      return selected;
    },

    removeTag(tag) {
      this.$emit("removeTag", tag.id);
      tag.checked = false;
      this.removeOption(tag)
    },

    handleClickOutside(event) {
      if (this.$refs.combobox && !this.$refs.combobox.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },

  mounted() {
    // Add a global click event listener
    document.addEventListener("click", this.handleClickOutside);
  },
};
</script>

<style>
.cloud_input {
  border: 1px solid #878e99;
  min-height: 40px;
  padding: 8px 15px;
  width: 100%;
  border-radius: 5px;
  color: #321c3b;
  line-height: 120%;
  letter-spacing: 0.015em;
  outline: none;
}

div[contenteditable="true"]:focus {
  outline: none;
}

.tag {
  padding: 4px 12px;
  background-color: #f1f1f1;
}
</style>